import type { Priority, Inventory, ClientGroup, CustomField } from '@/types';

// BE Schema
export type AppointmentResponseItem = {
  _id: string;
  orgId: string;
  created: string;
  updated: string;
  rollout: string;
  name: string;
  description: string;
  inventory: string;
  clientGroups: string[];
  priority: Priority;
  duration: number;
  maxParallel: number;
  dateFrom: Date | string;
  dateTo: Date | string;
  emailCustomField?: string;
  unavailableTimeframes?: {
    dateFrom: string;
    dateTo: string;
    isAllDayTimespan: boolean;
  }[];
};

// FE
export type Appointment = {
  _id?: string;
  rollout: string;
  name: string;
  description: string;
  inventory?: Inventory;
  priority: Priority;
  clientGroups: ClientGroup[];
  clientGroupCondition?: AppointmentClientGroupCondition;
  duration: number;
  maxParallel: number;
  dateFrom?: Date | string;
  dateTo?: Date | string;
  emailCustomField?: CustomField;
  unavailableTimeframes?: {
    dateFrom: Date | string;
    dateTo: Date | string;
    isAllDayTimespan: boolean;
  }[];
};

export enum AppointmentClientGroupCondition {
  AND = 'AND',
  OR = 'OR',
}
